import { useSelector } from 'react-redux'

import { selectCockpitInitiativesPlanQualitySummary } from '../../../model/selectors'

/** The score the Plan Quality tab wears, read by the header's view switch and by the expanded
 *  tile's export alike. Shown regardless of `IsPlanned` — see the README's Plan Quality note. */
export const useInitiativesQualityScore = () => {
  const { selectedQuality: quality } = useSelector(selectCockpitInitiativesPlanQualitySummary)

  return quality?.overall.score ?? null
}
